import { Heading_3 as Heading3 } from '@huggg/react-components';
import PropTypes from 'prop-types';
import React from 'react';
import styles from './title.module.scss';

const Title = ({ children }) => {
  return <Heading3 className={styles.title}>{children}</Heading3>;
};

Title.propTypes = {
  children: PropTypes.node,
};

export default Title;
